import { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { BrandLogo } from '../components/BrandLogo';
import api from '../lib/api';
import { BDAFAuditWidget } from '../components/BDAFAudit';
import { useAuth } from '../contexts/AuthContext';

export default function AuditPage() {
  const { id } = useParams();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const src = params.get('src');
    if (src) sessionStorage.setItem('adoptic_src', src);
    if (!loading && !user) { navigate(`/login?next=${encodeURIComponent(`/audit/${id}${src ? `?src=${src}` : ''}`)}`, { replace: true }); return; }
    if (loading) return;
    api.get(`/claims/business/${id}`).then(r => setData(r.data)).catch(() => setError('We could not find this business in the Adoptic register.'));
  }, [id, user, loading, navigate]);

  return (
    <div className="min-h-screen bg-page-bg" data-testid="audit-page">
      <header className="h-16 border-b border-warm-border bg-white/80 backdrop-blur-md flex items-center">
        <div className="max-w-[1200px] mx-auto px-4 lg:px-6 w-full flex items-center justify-between">
          <BrandLogo testId="audit-brand" />
          <Link to={user ? '/dashboard' : '/login'} className="font-body text-sm font-medium text-ink-2 hover:text-brand-orange transition-colors" data-testid="audit-signin">{user ? 'Open app' : 'Sign in'}</Link>
        </div>
      </header>
      <main className="max-w-[760px] mx-auto px-4 lg:px-6 py-12 space-y-8">
        <div>
          <p className="font-body text-[11px] uppercase tracking-[0.14em] text-brand-orange font-semibold mb-3">Free BDAF audit</p>
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-ink leading-[1.05] tracking-tight">Your digital footprint,<br />in five signals.</h1>
          <p className="font-body text-base text-ink-2 mt-4 max-w-xl leading-relaxed">The Business Digital Adoption Framework scores every registered business on website, Google Business Profile, directory listings, social media and customer reviews — automatically, without surveys.</p>
        </div>
        {error && <div className="solid-card p-6 font-body text-sm text-status-red" data-testid="audit-error">{error}</div>}
        {!data && !error && <div className="solid-card p-10 text-center font-body text-sm text-mid">Running audit…</div>}
        {data && <BDAFAuditWidget data={data} ownerMode={data.is_mine} />}
        {data?.is_mine && <Link to="/my-business" className="inline-flex font-body text-sm font-semibold text-brand-orange hover:underline" data-testid="audit-open-dashboard">Open my business dashboard →</Link>}
        <p className="font-body text-xs text-mid">Source: Companies House (OGL v3.0) · Ofcom Connected Nations · ONS IMD 2025 · BDAF engine</p>
      </main>
    </div>
  );
}
